export default __webpack_public_path__ + "static/media/Provider_certification.cf1af403.svg";